import Dashboard from "views/Dashboard/Dashboard";
import Customers from "views/Customers/Customers";
import Backup from "views/Backup/Backup";
import Drivers from "../views/Drivers/Drivers";
import CustomerInfo from "../views/Customers/CustomerInfo";
import RegisterNewCustomer from "../views/Customers/RegisterNewCustomer";
import Services from "../views/Services/Services";
import Logout from "../views/Logout";
import RouteRedirector from "../views/Customers/RouteRedirector";
const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "میز کار",
    icon: "pe-7s-graph",
    component: Dashboard,
  },
  {
    path: "/customers",
    name: "مشتریان",
    icon: "pe-7s-users",
    component: Customers,
  },
  {
    path: "/drivers",
    name: "رانندگان",
    icon: "pe-7s-car",
    component: Drivers,
  },
  {
    path: "/services",
    name: "خدمات",
    icon: "pe-7s-news-paper",
    component: Services,
  },
  {
    path: "/backup",
    name: "پشتیبان گیری",
    icon: "pe-7s-download",
    component: Backup,
  },
  {
    path: "/logout",
    name: "خروج",
    icon: "pe-7s-back",
    component: Logout,
  },
  {
    content: true,
    path: "/userrouter/:call?",
    component: RouteRedirector,
  },
  {
    content: true,
    path: "/info/:call?",
    component: CustomerInfo,
  },
  {
    content: true,
    path: "/register/:call?",
    component: RegisterNewCustomer,
  },
  { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" },
];

export default dashboardRoutes;
